import {
    getTag,
    listTags
} from './queries';
import {
    createTag,
    deleteTag,
    updateTag,
} from './mutations';

import { GraphQLQuery } from 'aws-amplify/api';
import {
    CreateTag,
    DeleteTag,
    GetTag,
    ListTags,
    Tag,
    UpdateTag
} from "../types.ts";
import {
    showErrorNotifications,
    showSuccessNotification
} from "../../../components/ServiceNotifications.tsx";
import { client } from '../../email-api-integration';

export const fetchRecords = async ({
    limit = 10,
    nextToken = null
}: {
    limit?: number,
    nextToken?: string | null
} = {}) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListTags>>({
            query: listTags,
            variables: {
                limit: limit,
                nextToken: nextToken
            },
        });
        const result = {
            items: response.data?.listTags.items || [],
            nextToken: response.data?.listTags.nextToken || null
        };
        
        if (result.items.length === 0) {
            return { items: [], nextToken: null };
        }
        
        return result;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        throw e;
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetTag>>({
        query: getTag,
        variables: {id: id},
    });
    return response.data?.getTag;
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateTag>>({
                                                                           query: createTag,
                                                                           variables: {input: {...payload}},
                                                                       });
        console.debug('in the service response', response);

        showSuccessNotification('Tag created');
        return response.data?.createTag;
    } catch (e: any) {

        if (e.errors) {
            // filter out all other messages but the transaction cancelled exception
            e.errors = e.errors.filter((error: {
                errorType: string
            }) => error.errorType === 'DynamoDB:TransactionCanceledException')

            // iterate over the errors and replace the message if it is a duplicate
            e.errors.forEach((error: { errorType: string, message: string }) => {
                if (error.errorType === 'DynamoDB:TransactionCanceledException') {
                    error.message = 'Duplicate tag. please select another'
                }
            });
        }

        console.trace(e);
        showErrorNotifications(e)
    }
};

export const update = async (id: string, record: Tag) => {

    console.debug('IN UPDATE', id, record);

    // Whitelist to the fields UpdateTagInput accepts (id, name, description).
    // Sending any other field of the fetched record (createdByUsername,
    // managedByUsername, created, updated, recordType, …) makes AppSync reject the
    // whole mutation with "field not defined for input object type 'UpdateTagInput'"
    // and NOTHING is written (FNP-764, same class as the FNP-760 alias fix).
    // Whitelist, never blacklist — a delete-specific-fields trim silently regresses
    // whenever the record grows a new field.
    const input = {
        id: record.id,
        name: record.name,
        description: record.description,
    };

    try {
        const response = await client.graphql<GraphQLQuery<UpdateTag>>({
                                                                           query: (updateTag),
                                                                           variables: {input},
                                                                       });

        showSuccessNotification('Tag updated');
        return response.data?.updateTag;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

export const deleteRecord = async (id: string, name: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteTag>>({
                                                                           query: (deleteTag),
                                                                           variables: {
                                                                               input: {
                                                                                   id: id,
                                                                                   name: name,
                                                                               }
                                                                           },

                                                                       });
        showSuccessNotification('Tag deleted');
        return response.data?.deleteTag;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};
